import type { SVGProps } from 'react';

const SvgPlayerVolumeMax = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M4.01 9h2l4.24-4.95c.6-.7 1.76-.28 1.76.65v14.59c0 .93-1.16 1.36-1.76.65l-4.24-4.95h-2c-.55.01-1-.44-1-.99v-4c0-.55.45-1 1-1m11 11.41c-.4 0-.77-.24-.93-.62a1 1 0 0 1 .55-1.3A6.975 6.975 0 0 0 19.01 12c0-2.87-1.72-5.41-4.38-6.49a.998.998 0 1 1 .75-1.85A8.95 8.95 0 0 1 21 12c0 3.68-2.21 6.96-5.62 8.34-.12.05-.25.07-.38.07z"
    />
    <path
      fill="currentcolor"
      d="M15.01 15.62a1 1 0 0 1-.66-.25c-.42-.36-.46-1-.1-1.41.34-.39.75-1.05.75-1.96s-.41-1.57-.75-1.96a1 1 0 0 1 .1-1.41 1 1 0 0 1 1.41.1c.8.92 1.25 2.08 1.25 3.28s-.44 2.36-1.25 3.28c-.2.23-.47.34-.75.34z"
    />
  </svg>
);
export default SvgPlayerVolumeMax;
